import { SvgIcon } from "@material-ui/core";

export const FewItemsIcon = ({
  className,
  fontSize = 80,
}: {
  className?: string;
  fontSize?: number;
}) => {
  return (
    <SvgIcon
      className={className}
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      style={{ fontSize, fill: "none" }}
    >
      <g clipPath="url(#clip0_6802_10242)">
        <path
          d="M43.9535 29.9535H60.9303C62.2094 29.9535 63.2559 28.7907 63.1396 27.5117L61.2791 10.4186C61.1629 9.25585 60.2326 8.44189 59.0698 8.44189H45.814C44.6512 8.44189 43.721 9.25585 43.6047 10.4186L41.7442 27.5117C41.628 28.7907 42.6745 29.9535 43.9535 29.9535Z"
          fill="#F1CCA5"
        />
        <path
          d="M42.3257 63.9072H62.5582C63.0234 63.9072 63.3722 64.2561 63.3722 64.7212V66.1165C63.3722 66.5816 63.0234 66.9305 62.5582 66.9305H42.3257C41.8606 66.9305 41.5117 66.5816 41.5117 66.1165V64.7212C41.5117 64.2561 41.8606 63.9072 42.3257 63.9072Z"
          fill="#F1CCA5"
        />
        <path
          d="M45.814 28.2094H63.2559C64.4186 28.2094 65.3489 27.1629 65.2326 26.0001L63.3721 8.44194C63.2559 7.39543 62.4419 6.69775 61.3954 6.69775H47.7907C46.7442 6.69775 45.9303 7.51171 45.814 8.44194L43.9535 26.0001C43.721 27.1629 44.6512 28.2094 45.814 28.2094Z"
          stroke="#EB7200"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M54.5349 62.0467V28.2095"
          stroke="#226937"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M50.3489 62.0464H64.5349C65 62.0464 65.3489 62.3952 65.3489 62.8603V64.2557C65.3489 64.7208 65 65.0696 64.5349 65.0696H44.3024C43.8373 65.0696 43.4884 64.7208 43.4884 64.2557V62.9766C43.4884 62.5115 43.8373 62.1627 44.3024 62.1627"
          stroke="#EB7200"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M56.7441 48.2095H76.9767C77.4418 48.2095 77.7906 48.5583 77.7906 49.0234V50.4188C77.7906 50.8839 77.4418 51.2327 76.9767 51.2327H56.7441C56.279 51.2327 55.9302 50.8839 55.9302 50.4188V49.0234C55.9302 48.5583 56.279 48.2095 56.7441 48.2095Z"
          fill="#F1CCA5"
        />
        <path
          d="M58.9534 51.4653H74.8837C75.3488 51.4653 75.6976 51.8142 75.6976 52.2793V59.9537C75.6976 60.4188 75.3488 60.7677 74.8837 60.7677H58.9534C58.4883 60.7677 58.1395 60.4188 58.1395 59.9537V52.2793C58.0232 51.8142 58.4883 51.4653 58.9534 51.4653Z"
          fill="#F1CCA5"
        />
        <path
          d="M3.95346 47.2793V40.4188C3.95346 38.2095 5.69765 36.4653 7.90696 36.4653H40C42.2093 36.4653 43.9535 38.2095 43.9535 40.4188V47.2793C46.3953 47.2793 48.3721 49.256 48.3721 51.6979V59.8374V67.5118H-2.28882e-05V59.8374V51.6979C-0.116302 49.3723 1.74416 47.5118 3.95346 47.2793Z"
          fill="#F1CCA5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.9768 64.4883C46.6279 64.4883 46.2791 64.8371 46.2791 65.186V71.6976C46.2791 72.0464 46.6279 72.3953 46.9768 72.3953C47.3256 72.3953 47.6744 72.0464 47.6744 71.6976V65.186C47.6744 64.7208 47.3256 64.4883 46.9768 64.4883Z"
          fill="#EA7200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.46516 64.4883C5.11632 64.4883 4.76749 64.8371 4.76749 65.186V71.6976C4.76749 72.0464 5.11632 72.3953 5.46516 72.3953C5.814 72.3953 6.16284 72.0464 6.16284 71.6976V65.186C6.16284 64.7208 5.93028 64.4883 5.46516 64.4883Z"
          fill="#EA7200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.3256 51.349C42.3256 51.0001 42.093 50.7676 41.7442 50.7676H10.9302C10.5814 50.7676 10.3488 51.0001 10.3488 51.349C10.3488 51.6978 10.5814 51.9304 10.9302 51.9304H41.7442C41.9767 51.9304 42.3256 51.6978 42.3256 51.349Z"
          fill="#006A36"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5116 49.3721C11.5116 46.5814 9.30231 44.2559 6.39534 44.2559C3.60464 44.2559 1.27906 46.5814 1.27906 49.3721V65.8838H51.0465V49.3721C51.0465 46.5814 48.8372 44.2559 45.9302 44.2559C43.1395 44.2559 40.8139 46.4652 40.8139 49.3721V56.814H11.3953V49.3721H11.5116ZM6.39534 45.6512C8.48836 45.6512 10.1163 47.2791 10.1163 49.3721V58.0931H42.3256V49.3721C42.3256 47.2791 43.9535 45.6512 46.0465 45.6512C48.1395 45.6512 49.7674 47.2791 49.7674 49.3721V64.4884H2.79069V49.3721C2.67441 47.2791 4.41859 45.6512 6.39534 45.6512Z"
          fill="#EA7200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99995 33.4419C7.44181 33.4419 5.34879 35.5349 5.34879 38.0931V44.9535H6.74414V38.0931C6.74414 36.2326 8.25576 34.8372 9.99995 34.8372H42.093C43.9534 34.8372 45.3488 36.3489 45.3488 38.0931V44.9535H46.7441V38.0931C46.7441 35.5349 44.6511 33.4419 42.093 33.4419H9.99995Z"
          fill="#EA7200"
        />
        <path
          d="M58.2559 46.5815H78.4884C78.9535 46.5815 79.3024 46.9304 79.3024 47.3955V48.7908C79.3024 49.256 78.9535 49.6048 78.4884 49.6048H58.2559C57.7907 49.6048 57.4419 49.256 57.4419 48.7908V47.3955C57.4419 46.9304 57.7907 46.5815 58.2559 46.5815Z"
          stroke="#EB7200"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M60.3488 49.8374H76.2791C76.7442 49.8374 77.093 50.1862 77.093 50.6514V58.3258C77.093 58.7909 76.7442 59.1397 76.2791 59.1397H60.3488C59.8837 59.1397 59.5349 58.7909 59.5349 58.3258V50.6514C59.5349 50.1862 59.8837 49.8374 60.3488 49.8374Z"
          stroke="#EB7200"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M61.9768 72.3955V59.1396H74.7675V72.3955"
          stroke="#EB7200"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M70.6976 52.9766H65.9302"
          stroke="#226937"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6802_10242">
          <rect
            width="80"
            height="67.093"
            fill="white"
            transform="matrix(-1 0 0 1 80 6)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
